<template>
    <v-card elevation="0" class="review-stats pa-4" color="#f4f5f6" v-if="stats">
        <v-row>
            <v-col cols="12" sm="4" class="text-center">
                <div class="overall-rating">
                    <span class="rating-number">{{ stats.bayesian_rating ? stats.bayesian_rating.toFixed(1) : '0.0' }}</span>
                    <RatingStars :value="stats.bayesian_rating || 0" :readonly="true" :size="28" />
                    <p class="review-count mt-2">{{ stats.review_count || 0 }} {{ stats.review_count === 1 ? 'review' : 'reviews' }}</p>
                </div>
            </v-col>
            <v-col cols="12" sm="8">
                <div class="rating-distribution">
                    <div v-for="rating in [5,4,3,2,1]" :key="rating" class="distribution-row d-flex align-center mb-1">
                        <span class="rating-label">{{ rating }}</span>
                        <v-icon small color="#FFD700" class="mx-1">mdi-star</v-icon>
                        <v-progress-linear
                            :value="getPercentage(rating)"
                            color="primary"
                            height="8"
                            class="mx-2 flex-grow-1"
                            rounded
                        />
                        <span class="rating-count">{{ getCount(rating) }}</span>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import RatingStars from '../RatingStars.vue';

export default {
    name: 'ReviewStats',
    components: {
        RatingStars
    },
    props: {
        stats: {
            type: Object,
            default: null
        },
        reviews: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ratingDistribution() {
            const distribution = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
            if (this.reviews && this.reviews.length > 0) {
                this.reviews.forEach(review => {
                    if (review.rating >= 1 && review.rating <= 5) {
                        distribution[review.rating]++;
                    }
                });
            }
            return distribution;
        }
    },
    methods: {
        getPercentage(rating) {
            const total = this.reviews.length;
            if (total === 0) return 0;
            return (this.ratingDistribution[rating] / total) * 100;
        },
        getCount(rating) {
            return this.ratingDistribution[rating];
        }
    }
}
</script>

<style scoped>
.overall-rating .rating-number {
    font-size: 48px;
    font-weight: 700;
    display: block;
    color: #333;
}
.review-count {
    color: #666;
    font-size: 14px;
}
.rating-label {
    width: 20px;
    text-align: right;
    font-weight: 600;
}
.rating-count {
    width: 30px;
    text-align: left;
    color: #666;
    font-size: 14px;
}
</style>
